import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogModalComponent } from 'src/app/components/dialog-modal/dialog-modal.component';
import { pdpApiService } from 'src/app/services/pdp-api.service';
import { GoogleAnalyticsEventsService } from "../../services/google-analytics.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  currentlang: any;
  state: number = 0;
  isLoading: boolean = false;
  msisdnType: string = '';
  loginForm: FormGroup | any;
  validationMsisdnLength: boolean = false;
  validationNo: boolean = false;
  submitted = false;
  modalRef: any;

  channel: string = '';
  hash: string = '';
  timestamp: string = '';
  msisdn: string = '';
  jwt_client: string = '';
  usertype: string = '';
  language: string = '';
  isAutoLogin: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private modalService: NgbModal,
    private pdpService: pdpApiService,
    private route: ActivatedRoute,
    public googleAnalyticsService: GoogleAnalyticsEventsService,
  ) {
    translate.addLangs(['id', 'en']);
    this.route.queryParams.subscribe(params => {
      this.hash = params['hash'] || params['jwt_token'];
      this.timestamp = params['timestamp'];
      this.msisdn = params['msisdn'];
      this.jwt_client = params['jwt_client'];
      this.usertype = params['usertype'];
      this.language = params['language'] ?? 'id';

      // let platform = 'indosat';
      // if (params['apps']?.toLowerCase() === 'bima') {
      //   platform = 'tri';
      // } else if (params['apps']?.toLowerCase() === 'myim3') {
      //   platform = 'im3';
      // }

      // const platform = params['hash'] ? 'tri' : (params['jwt_token'] ? 'im3' : 'indosat')
      // localStorage.setItem('platform', 'indosat');

      this.channel = params['channel'] ? params['channel'] : 'WEB_PORTAL';
      localStorage.setItem('source', this.channel);

      // Set the platform here right away, do not wait for the validate hash response.
      // Or the isMobile variable in the header component will have to wait longer.
      if (this.channel === 'MYIM3') {
        localStorage.setItem('platform', 'im3');
      } else if (this.channel === 'BIMA' || this.channel === 'BIMA_OLD' || this.channel === 'BIMASUPERAPP') {
        localStorage.setItem('platform', 'tri');
      } else {
        localStorage.setItem('platform', 'indosat');
      }

      localStorage.setItem('language', this.language.toLowerCase());
      this.autoLogin();
    });
  }

  ngOnInit(): void {
    this.currentlang = localStorage.getItem('language');

    if (this.currentlang === null) {
      localStorage.setItem('language', 'id');
      this.translate.use('id');
      this.translate.setDefaultLang('id');
    } else {
      this.translate.use(this.currentlang);
      this.translate.setDefaultLang(this.currentlang);
    }

    this.loginForm = this.formBuilder.group({
      msisdn: ['', [Validators.required]],
    });
  }

  get f() { return this.loginForm.controls; }

  setChildMsisdn(): any {
    // let AllowedNumberTri: Array<string> = ['62895', '62896', '62897', '62898', '62899', '0899',
    //   '0898', '0897', '0896', '0895'];
    // let AllowedNumberIm3: Array<string> = ['62858', '62857', '62856', '62855', '62814', '62815', '62816',
    //   '0858', '0857', '0856', '0855', '0814', '0815', '0816'];

    let AllowedNumberTri: Array<string> = ['899', '898', '897', '896', '895'];
    let AllowedNumberIm3: Array<string> = ['858', '857', '856', '855', '814', '815', '816'];

    if (this.f.msisdn.value != undefined) {
      if (AllowedNumberTri.find((numb) =>
        this.f.msisdn.value.toString().substring(0, 3) === numb)) {
        this.msisdnType = 'TRI';
        this.validationNo = false;
      } else {
        if (AllowedNumberIm3.find((numb) =>
          this.f.msisdn.value.toString().substring(0, 3) === numb)) {
          this.msisdnType = 'IM3';
          this.validationNo = false;
        } else {
          this.msisdnType = '';
          this.validationNo = true;
        }
      }

      this.validationMsisdnLength = this.f.msisdn.value.length >= 9 ? false : true;
    }
  }

  formDisabled() {
    if (this.f.msisdn.errors || this.validationMsisdnLength || this.validationNo) {
      return true
    } else {
      return false
    }
  }

  autoLogin() {
    if (this.hash) {
      this.isLoading = true;
      this.pdpService.validateHash(this.hash, this.timestamp, this.msisdn, this.jwt_client, this.usertype, this.language, this.channel).subscribe(res => {
        this.isLoading = false;
        if (res.status) {
          let data = res.data.data;

          if (data.channel === 'MYIM3') {
            localStorage.setItem('platform', 'im3');
          } else if (data.channel === 'BIMA' || data.channel === 'BIMA_OLD' ||
            data.channel === 'BIMASUPERAPP'
          ) {
            localStorage.setItem('platform', 'tri');
          }

          this.f.msisdn.value = data.msisdn;
          this.isAutoLogin = true;
          this.state = 1;
        }
      }, err => {
        this.isLoading = false;
      })
    }
    // else{
    //   //DUMMY BYPASS
    //       localStorage.setItem('platform', 'tri');
    //       this.isAutoLogin = true;
    //       this.state = 1;
    // }
  }

  login() {
    if (!this.formDisabled()) {
      this.isLoading = true;
      this.submitted = true;
      this.googleAnalyticsService.emitEvent("Generate OTP", "MSISDN", '62' + this.f.msisdn.value);
      this.pdpService.generateOtp('62' + this.f.msisdn.value, this.msisdnType).subscribe(res => {
        this.isLoading = false;
        if (res.status && res.data.OTPCommomServiceResp.ResponseCode === "00000") {
          this.state = 1;
        } else {
          // this.errorDialog();
        }
      }, err => {
        this.isLoading = false;
        // this.errorDialog();
      })
    }
  }

  errorDialog() {
    this.modalRef = this.modalService.open(DialogModalComponent, {
      size: 'md',
      centered: true,
      // backdrop: 'static',
      windowClass: 'dialog-modal'
    });
    this.modalRef.componentInstance.dialogType = 'invalid_number';
    this.modalRef.componentInstance.btnAction.subscribe((data: any) => {
      this.modalRef.close()
    });
  }

  resetState() {
    this.state = 0;
  }
}
